import * as yup from 'yup';
import { MilitaryStatus } from '@domain/constant/profile/PreferentialType';

const seekFormSchema = yup.object({
  military: yup
    .object()
    .when('militaryUseYn', {
      is: true,
      then: (schema) =>
        yup.lazy((military) => {
          if (!military) return schema;
          if (military.status === null)
            return schema.shape({
              status: yup.object().nullable().required('내용을 입력해주세요.'),
            });

          // 제대, 복무중인 경우에만 내부 필드 필수값
          if ([MilitaryStatus.IN_SERVICE, MilitaryStatus.DISCHARGE].includes(military.status?.value))
            return schema.shape({
              status: yup.object().nullable().required('내용을 입력해주세요.'),
              type: yup.object().nullable().required('군별을 입력해주세요.'),
              militaryClass: yup.object().nullable().required('계급을 입력해주세요.'),
              dischargeType: yup.lazy((_) => {
                return yup
                  .object()
                  .nullable()
                  .when('status', (status, schema) => {
                    // 복무 중인 경우 제대 구분 없음.
                    if (status?.value === MilitaryStatus.IN_SERVICE) return schema;

                    return schema.required('제대 구분을 입력해주세요.');
                  });
              }),
              startDate: yup.lazy((startDate) => {
                return startDate ? yup.date() : yup.string().nullable().required('입대 일자를 입력해주세요.');
              }),
              endDate: yup.lazy((endDate) => {
                return endDate
                  ? yup.date().when('startDate', (startDate, schema) => {
                      return startDate ? schema.min(startDate, '제대 일자가 입대 일자보다 빠릅니다.') : schema;
                    })
                  : yup
                      .string()
                      .nullable()
                      .when('status', (status, schema) => {
                        // 복무 중인 경우 종료일자 없음.
                        if (status?.value === MilitaryStatus.IN_SERVICE) return schema;

                        return schema.required('제대 일자를 입력해주세요.');
                      });
              }),
            });

          return schema.shape({
            status: yup.object().required('내용을 입력해주세요.'),
          });
        }),
      otherwise: (schema) => schema,
    })
    .nullable(true),
  militaryUseYn: yup.boolean(),

  disabilityUseYn: yup.boolean(),
  disability: yup
    .object()
    .nullable()
    .when('disabilityUseYn', {
      is: true,
      then: (schema) =>
        schema.shape({
          grade: yup.object().nullable().required('장애 등급을 입력해주세요'),
          type: yup
            .object()
            .nullable()
            .when('grade.value', {
              is: 'NONE',
              then: yup.object().nullable().notRequired(),
              otherwise: yup.object().nullable().required('내용을 입력해주세요.'),
            }),
        }),
      otherwise: (schema) => schema,
    }),

  veteranUseYn: yup.boolean(),
  veteran: yup
    .object()
    .nullable()
    .when('veteranUseYn', {
      is: true,
      then: (schema) =>
        schema.shape({
          status: yup.object().nullable().required('보훈 여부를 입력해 주세요.'),
          reason: yup.string().when('status.value', {
            is: 'NONE',
            then: yup.string().nullable().notRequired(),
            otherwise: yup.string().nullable().required('대상 사유를 입력해주세요.'),
          }),
        }),
      otherwise: (schema) => schema,
    }),
});

export default seekFormSchema;
